import React, { Component } from "react";
import "./index.css";
import moment from "moment";
import { Link } from "redux-little-router";
import ProfilePicture from "../../../../../ProfilePicture";
import mixpanel from "../../../../../../services/mixpanel";

class Notification extends Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose(...args) {
    this.props.closePopup(...args);
    mixpanel.track("notifications.read", {
      path: this.props.path,
      message: this.props.message,
    });
  }

  render() {
    const {
      actor: { picture, path: actorPath, actorId },
      path,
      isSeen,
      lastUpdatedAt,
      postTitle,
      message,
      closePopup,
    } = this.props;
    return (
      <Link href={path} onClick={this.handleClose}>
        <div className={`notification ${!isSeen ? "-seen" : ""}`}>
          <Link href={actorPath} onClick={closePopup}>
            <ProfilePicture userId={actorId} size="s" className="-avatar" fallbackUrl={picture} alt="user avatar" />
          </Link>
          <div className="-content">
            <div className="-text">{message}</div>
            {postTitle ? <div className="-case-title">{postTitle}</div> : null}
            <div className="-date">{moment(lastUpdatedAt).fromNow()}</div>
          </div>
        </div>
      </Link>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Header/Components/NotificationsIndicator/componenets/Notification/index.js